import React, { useEffect, useState } from 'react';
import { getTickerNews } from '../../services/newsApi';
import { KIND_LABEL, relTime, ShareActions } from './newsShared';
import './News.css';

/**
 * The latest few real headlines for one ticker, inline wherever a grade is
 * shown (GradeCard, and both screener layouts).
 *
 * Visible, not behind a toggle: a control nobody finds does not exist, and the
 * point is that the Reuters story is THERE when you look at the grade. Filler
 * is already removed server-side. Renders nothing if there is no news, so a
 * quiet ticker does not get an empty box.
 */
export default function TickerNews({ symbol, limit = 3, showAllLink = true }) {
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    if (!symbol) return undefined;
    let cancelled = false;
    setArticles(null);
    getTickerNews(symbol, limit)
      .then((d) => { if (!cancelled) setArticles(d.articles || []); })
      .catch(() => { if (!cancelled) setArticles([]); });
    return () => { cancelled = true; };
  }, [symbol, limit]);

  if (articles === null) {
    return <div className="tn tn-loading" aria-busy="true">Loading {symbol} news…</div>;
  }
  if (!articles.length) return null;

  return (
    <div className="tn" onClick={(e) => e.stopPropagation()}>
      <div className="tn-head">
        <span className="tn-title">📰 Latest on {symbol}</span>
        {showAllLink && (
          <a className="tn-all" href={`/news?symbol=${encodeURIComponent(symbol)}`}>
            All news →
          </a>
        )}
      </div>
      <ul className="tn-list">
        {articles.map((a) => (
          <li key={a.url} className="tn-item">
            <a className="tn-link" href={a.url} target="_blank" rel="noopener noreferrer">
              {a.title}
            </a>
            <div className="tn-meta">
              <span className={`nf-kind k-${a.kind}`}>{KIND_LABEL[a.kind] || a.kind}</span>
              <span>{a.source}</span>
              <span>· {relTime(a.published_at)}</span>
              <ShareActions article={a} symbol={symbol} compact />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
